import React, { useState } from 'react';
import { toast } from 'react-toastify';
import LoadingSpinner from '../components/LoadingSpinner';
import './Services.css';

const API_BASE = process.env.REACT_APP_FILE_API_URL;

const FileDownload = () => {
  const [fileId, setFileId] = useState('');
  const [loading, setLoading] = useState(false);

  const handleDownload = async (e) => {
    e.preventDefault();
    if (!fileId) return;
    setLoading(true);
    try {
      // Check if file exists before downloading
      const checkResponse = await fetch(`${API_BASE}/files/${fileId}`, {
        headers: {
          'Authorization': 'Basic YWRtaW46YWRtaW4='
        }
      });
      if (!checkResponse.ok) {
        toast.error('File not found');
        return;
      }
      window.open(`${API_BASE}/files/download/${fileId}`, '_blank');
      toast.success('Download started!');
    } catch (error) {
      toast.error(`Failed to download file: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="service-page">
      <h1>Download File</h1>
      <form onSubmit={handleDownload} className="file-upload-form">
        <input
          type="text"
          placeholder="Enter File ID"
          value={fileId}
          onChange={e => setFileId(e.target.value)}
          disabled={loading}
        />
        <button type="submit" disabled={loading || !fileId} className="submit-button">
          {loading ? <LoadingSpinner /> : 'Download'}
        </button>
      </form>
      {loading && <div className="loading-overlay"><LoadingSpinner /></div>}
    </div>
  );
};

export default FileDownload;
